import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";

const FormContainer = styled.div`
  position: relative;
  padding: 2rem;
  width: 70%;
  margin: 30px auto;
  border-radius: 1rem;
  background-color: ${({ theme }) => theme.body};
  color: ${({ theme }) => theme.text};
  z-index: 1;

  /* Frosted glass and glow effect */
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);

  /* Neon border glow */
  border: 1px solid ${({ theme }) => theme.greenLight};
  box-shadow: 0 0 0.5rem #00ffaa66, 0 0 1rem #00ffaa66,
    inset 0 0 0.3rem #00ffaa33;

  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.015);
    box-shadow: 0 0 1rem #00ffaa88, 0 0 1.5rem #00ffc355,
      inset 0 0 0.5rem #00ffaa44;
  }

  @media (max-width: 968px) {
    width: 85%;
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    width: 95%;
    padding: 1rem;
  }
`;

const FormCard = ({ children }) => {
  return <FormContainer>{children}</FormContainer>;
};

export default FormCard;
